export default { sha: '4e766fad2e553559c9762fdf597f1ab24659f2fb', buildNumber: 'undefined' }
